// extracted by mini-css-extract-plugin
export default {"container":"TitleSection_container__8kJng","main-text":"TitleSection_main-text__6VWnE","bg-text":"TitleSection_bg-text__5nnjz"};